import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoxmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.571 3.405a.5.5 0 0 0-.31-.463L8.19.038a.5.5 0 0 0-.38 0L.74 2.942a.5.5 0 0 0-.31.463v9.19a.5.5 0 0 0 .31.463l7.07 2.905a.5.5 0 0 0 .38 0l7.07-2.905a.5.5 0 0 0 .311-.463v-9.19Zm-7.57 2.406L5.394 4.74l5.63-2.457 2.78 1.142L8 5.811ZM1.43 4.194l2.247.923v2.605a.5.5 0 0 0 1.002 0V5.53L7.5 6.687v8.066l-6.07-2.494V4.194ZM8 1.042l1.735.713-5.63 2.456-1.91-.785L8 1.042Zm.5 5.645 6.07-2.493v8.065L8.5 14.753V6.687Z",
			fill: "currentColor "
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgBoxmin);
export { ForwardRef as ReactComponent };
